import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface RiskReturnChartStepProps {
  onContinue: () => void;
}

const RiskReturnChartStep = ({ onContinue }: RiskReturnChartStepProps) => {
  return (
    <div className="space-y-4">
      <p className="text-gray-600">Review your portfolio's risk-return profile.</p>
      <div className="space-y-4">
        {/* Risk-return chart will go here */}
        <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
          Risk-Return Chart Placeholder
        </div>

        <div className="pt-6">
          <Button size="lg" className="w-full max-w-md" onClick={onContinue}>
            Continue
            <ChevronRight className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RiskReturnChartStep;